import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

import AddressSelectModal, {
  AddressOption,
} from 'components/Granel/AddressSelectModal';

import {
  changeProfile,
  descreverEndereco,
  getAddresses,
  getUserId,
  idDoEndereco,
  limparSelecaoPendente,
  persistSelection,
  selecaoPendente,
  syncContactIdSf,
  UserAddress,
} from './services';

const AddressGate = (): JSX.Element | null => {
  const [addresses, setAddresses] = useState<UserAddress[]>([]);
  const [selecionado, setSelecionado] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selecaoPendente()) return;

    const carregar = async (): Promise<void> => {
      const login = localStorage.getItem('@UltragazEmpresarial:loginEmail');

      if (!login) {
        limparSelecaoPendente();
        return;
      }

      try {
        const userId = await getUserId(login);
        const lista = await getAddresses(userId);

        if (lista.length <= 1) {
          limparSelecaoPendente();
          return;
        }

        setAddresses(lista);
        setSelecionado(idDoEndereco(lista[0]));
      } catch {
        limparSelecaoPendente();
      }
    };

    carregar();
  }, []);

  const opcoes: AddressOption[] = useMemo(
    () =>
      addresses.map((item) => ({
        id: idDoEndereco(item),
        title: item.address.name,
        description: descreverEndereco(item.base),
      })),
    [addresses]
  );

  const confirmar = useCallback(async () => {
    const escolhido = addresses.find(
      (item) => idDoEndereco(item) === selecionado
    );

    if (!escolhido) return;

    const login = localStorage.getItem('@UltragazEmpresarial:loginEmail') ?? '';

    setLoading(true);
    try {
      const novoToken = await changeProfile(
        escolhido.address.userCustomerRelationshipId,
        login
      );

      if (novoToken) {
        localStorage.setItem('@UltragazEmpresarial:accessToken', novoToken);
      }

      persistSelection(escolhido);
      await syncContactIdSf(escolhido.base.siteId);
      limparSelecaoPendente();

      window.location.replace('/portal');
    } catch (error) {
      setLoading(false);
      const mensagem = (error as { response?: { data?: { message?: string } } })
        ?.response?.data?.message;
      toast.error(mensagem ?? 'Não foi possível selecionar o endereço.');
    }
  }, [addresses, selecionado]);

  if (addresses.length <= 1) return null;

  return (
    <AddressSelectModal
      open
      dismissible={false}
      title="Bem vindo ao portal Minha Ultragaz"
      confirmLabel="Acessar"
      addresses={opcoes}
      value={selecionado}
      loading={loading}
      onChange={setSelecionado}
      onConfirm={confirmar}
      onClose={() => undefined}
    />
  );
};

export default AddressGate;
